import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox, MessageBox } from "reusableComponents";

import styles from "./styles.module.scss";

const DispositionTypes = ({
  space,
  formData,
  setFormData,
  errors,
  dispositionTypes,
  capacity, // Add capacity as a prop
}) => {
  const { t } = useTranslation("global");

  // Set the default disposition type when the component mounts
  // useEffect(() => {
  //   if (dispositionTypes.length > 0 && !formData.disposition_type) {
  //     const enabledType = dispositionTypes.find(
  //       (type) => !type.disabled && type.count >= capacity
  //     );
  //     setFormData((prev) => ({
  //       ...prev,
  //       disposition_type: enabledType ? enabledType.key : null,
  //     }));
  //   }
  // }, [dispositionTypes, setFormData, formData.disposition_type, capacity]);

  // Deselect the disposition type if capacity exceeds its count
  useEffect(() => {
    const selectedDisposition = dispositionTypes.find(
      (type) => type.key === formData.disposition_type
    );

    if (selectedDisposition && selectedDisposition.count < capacity) {
      setFormData((prev) => ({ ...prev, disposition_type: null }));
    }
  }, [capacity, dispositionTypes, formData.disposition_type, setFormData]);

  // Handle checkbox click
  const handleCheckboxChange = (disposition_type, disabled) => {
    if (!disabled) {
      setFormData((prev) => ({ ...prev, disposition_type }));
    }
  };

  // Render the capacity options
  return (
    <div>
      <h4
        dangerouslySetInnerHTML={{
          __html: t("booking.step2.disposition"),
        }}
      ></h4>
      {dispositionTypes?.length > 0 ? (
        <>
          {" "}
          <div className={styles.capacityIcons}>
            {dispositionTypes.map(({ key, count, Icon, name, disabled }) => (
              <div
                className={`${styles.capacityItem} ${
                  disabled || count < capacity ? styles.disabled : ""
                } ${formData.disposition_type === key ? styles.selected : ""}`}
                key={key}
                onClick={() =>
                  handleCheckboxChange(key, disabled || count < capacity)
                }
              >
                <Checkbox
                  checked={formData.disposition_type === key}
                  label={
                    <div className={`${styles.capacityItemCheckboxLabel} `}>
                      <div className={styles.capacityIconContainer}>
                        <Icon
                          className={`${styles.capacityIcon} ${
                            disabled || count < capacity
                              ? styles.disabledIcon
                              : ""
                          }`}
                          aria-label={name}
                        />
                      </div>
                      <div className={styles.capacityItemText}>
                        <span className={styles.capacityName}>{name}</span>

                        <span className={styles.maxCapacity}>
                          {`${t("booking.step2.max")} ${count} ${t(
                            "provide.step2.area.people"
                          )}`}
                        </span>
                      </div>
                    </div>
                  }
                  id={`checkbox-${key}`}
                  disabled={disabled || count < capacity}
                />
              </div>
            ))}
          </div>
          {errors?.find((error) => error.code === "disposition_type")
            ?.message && (
            <MessageBox
              type="error"
              message={
                errors?.find((error) => error.code === "disposition_type")
                  ?.message
              }
            />
          )}
        </>
      ) : (
        <p className={styles.noChoicesText}>No disposition choices are available for this space.</p>
      )}
    </div>
  );
};

export default DispositionTypes;
